module.exports = __webpack_public_path__ + "static/media/loading.5e4e421c.svg";